var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21385 2.02878L21.8004 0.726318L23 5.39298L7 4.72423L8.21385 2.02878Z",
    fill: "#CD566C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.826172 10.2997C1.09951 9.33299 1.72617 9.26633 2.33951 9.23966C8.54617 8.95966 14.7528 9.06633 20.9595 9.09966C21.2462 9.09966 21.5328 9.25966 21.7928 9.33966C22.2195 10.2397 21.8662 10.6797 21.0262 10.773C20.2995 10.853 19.5662 10.8597 18.8395 10.853C13.6062 10.8463 8.37284 10.8263 3.13284 10.8063C2.35951 10.8063 1.56617 10.8597 0.826172 10.2997Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4789 3.5197C22.2389 4.36636 21.6255 4.37303 20.9989 4.39303C14.6322 4.5997 8.25887 4.59303 1.88554 4.57303C1.33887 4.57303 0.78554 4.55969 0.512207 3.92636C0.738874 2.92636 1.51887 3.01969 2.23221 2.99969C4.95887 2.93303 7.69221 2.84636 10.4189 2.7997C13.8189 2.7397 17.2122 2.70636 20.6122 2.6797C21.3122 2.6797 22.1255 2.46636 22.4789 3.51303V3.5197Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3131 16.4863C16.0864 17.1129 15.6664 17.2863 15.1397 17.2729C10.7664 17.1463 6.37305 17.3463 2.01305 16.8329C1.76638 16.8063 1.53972 16.7329 1.31305 16.4196C1.08638 15.5263 1.70638 15.4196 2.44638 15.4196C4.02638 15.4196 5.61305 15.3996 7.19305 15.4196C9.68638 15.4529 12.1797 15.4996 14.673 15.5863C15.293 15.6063 16.0864 15.4663 16.3131 16.4929V16.4863Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0527 16.2663C19.1861 14.893 20.6261 15.453 21.9327 15.4263C22.5061 15.413 22.7127 15.8863 22.6127 16.5663C21.0461 17.0997 19.5394 17.073 18.0527 16.2663Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBar);
export default __webpack_public_path__ + "static/media/icon-bar.6973a6ba311b3883d411f5d3283691b2.svg";
export { ForwardRef as ReactComponent };